import classNames from 'classnames';
import css from './Steps.module.scss';
import { generateUniqueId } from '../../../../common/utils/utils';

const Steps = ({ steps = [], activeStep, children }) => {
    const currentStep = steps[activeStep];
    return (
        <div className={css.wrapper}>
            <div className={css.content}>
                {steps.map((step, i) => (
                    <div className={css.step} key={`step_0${i}`}>
                        <p className={classNames(css.stepTitle, { [css.stepTitleActive]: activeStep >= i })}>{step.title}</p>
                        <div className={classNames(css.stepLine, { [css.stepLineActive]: activeStep >= i })}></div>
                    </div>
                ))}
            </div>
            <p className={classNames(css.stepTitleBig, !currentStep.subtitle && css.stepTitleBigMargin)}>{currentStep.title}</p>
            {Array.isArray(currentStep.subtitle) ? (
                <div className={css.stepArray}>
                    {currentStep.subtitle?.map((it) => (
                        <p key={generateUniqueId()}>{it}</p>
                    ))}
                </div>
            ) : currentStep.subtitle ? (
                <p className={css.stepSubtitle}>{currentStep.subtitle}</p>
            ) : null}
            <div className={css.childComponent}>{children}</div>
        </div>
    );
};

export default Steps;
